module.exports = __webpack_public_path__ + "img/myposition_cm_토니 크로스.db6a3c19.png";